/**
 * TANK TOP — selector de cantidad (1/2/4) + color por prenda.
 * Agrega N unidades reales del producto al carrito en una sola llamada a
 * /cart/add.js, por lo que descuenta siempre del mismo inventario real.
 *
 * "Agregar al carrito": agrega en silencio (como el resto del tema) y avisa
 * al ícono/drawer del carrito vía el evento nativo `cart:update`, sin navegar.
 * "Comprar ahora": agrega y lleva directo a /checkout.
 *
 * Los precios mostrados deben coincidir con los descuentos automaticos
 * "TANK TOP x2 - promo cantidad" y "TANK TOP x4 - promo cantidad" en Shopify.
 */
(function () {
  // Precio del combo (1/2/4 prendas) ANTES de multiplicar por el stepper de paquetes.
  var TIER_PRICE_BY_QTY = {
    1: 64900,
    2: 116900,
    4: 203900,
  };

  // Mismo formato que ya usa el bloque nativo de precio (product-price .money): "$58,900.00".
  function formatMoney(amount) {
    return '$' + Math.round(amount).toLocaleString('en-US') + '.00';
  }

  function init(root) {
    var priceContainer = root.closest('[class*="product-details"]') || document;
    var mainPrice = priceContainer.querySelector('product-price');

    function updateMainPrice() {
      if (!mainPrice) return;
      var total = TIER_PRICE_BY_QTY[currentQty()] * currentPacks();
      var formatted = formatMoney(total);
      mainPrice.querySelectorAll('.money').forEach(function (el) {
        el.textContent = formatted;
      });
    }

    var variantsScript = root.querySelector('[data-combo-variants]');
    var variantMap = {};
    try {
      variantMap = JSON.parse(variantsScript.textContent);
    } catch (e) {
      variantMap = {};
    }

    var qtyLabel = root.querySelector('[data-combo-qty-label]');
    var tallaLabel = root.querySelector('[data-combo-talla-label]');
    var unitFieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-combo-unit]'));
    var errorEl = root.querySelector('[data-combo-error]');
    var addButton = root.querySelector('[data-combo-add]');
    var addButtonText = root.querySelector('[data-combo-add-text]');
    var buyNowButton = root.querySelector('[data-combo-buy-now]');
    var packsInput = root.querySelector('[data-combo-packs-input]');
    var packsMinus = root.querySelector('[data-combo-packs-minus]');
    var packsPlus = root.querySelector('[data-combo-packs-plus]');
    var packsWrapper = root.querySelector('[data-combo-packs-wrapper]');

    function currentQty() {
      var checked = root.querySelector('[data-combo-qty]:checked');
      return checked ? parseInt(checked.value, 10) : 1;
    }

    function currentPacks() {
      var value = parseInt(packsInput.value, 10);
      return value > 0 ? value : 1;
    }

    function currentTalla() {
      var checked = root.querySelector('[data-combo-talla]:checked');
      return checked ? checked.value : '';
    }

    function unitColor(unitIndex) {
      var fieldset = unitFieldsets[unitIndex - 1];
      var checked = fieldset.querySelector('[data-combo-color]:checked');
      return checked ? checked.value : '';
    }

    function hideError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function showError(message) {
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function updatePacksVisibility() {
      var isSingle = currentQty() === 1;
      packsWrapper.hidden = !isSingle;
      if (!isSingle) {
        packsInput.value = '1';
      }
    }

    function updateUnitsVisibility() {
      var qty = currentQty();
      unitFieldsets.forEach(function (fieldset, i) {
        fieldset.hidden = i >= qty;
      });
    }

    function updateAvailability() {
      var talla = currentTalla();
      unitFieldsets.forEach(function (fieldset) {
        if (fieldset.hidden) return;
        var inputs = fieldset.querySelectorAll('[data-combo-color]');
        inputs.forEach(function (input) {
          var label = input.closest('.variant-option__button-label');
          var strike = label.querySelector('[data-combo-strike]');
          var key = talla + '__' + input.value;
          var info = variantMap[key];
          var available = !!(info && info.available);
          input.disabled = !available;
          label.classList.toggle('is-disabled', !available);
          if (strike) strike.hidden = available;
          if (!available && input.checked) {
            input.checked = false;
          }
        });
        // If nothing valid is selected for this unit anymore, pick the first available color.
        var stillChecked = fieldset.querySelector('[data-combo-color]:checked');
        if (!stillChecked) {
          var firstAvailable = fieldset.querySelector('[data-combo-color]:not(:disabled)');
          if (firstAvailable) firstAvailable.checked = true;
        }
      });
    }

    function updateLabels() {
      qtyLabel.textContent = currentQty() + (currentQty() === 1 ? ' unidad' : ' unidades');
      tallaLabel.textContent = currentTalla();
      unitFieldsets.forEach(function (fieldset) {
        if (fieldset.hidden) return;
        var label = fieldset.querySelector('[data-combo-color-label]');
        var checked = fieldset.querySelector('[data-combo-color]:checked');
        if (label && checked) label.textContent = checked.value;
      });
    }

    function refresh() {
      updatePacksVisibility();
      updateUnitsVisibility();
      updateAvailability();
      updateLabels();
      updateMainPrice();
    }

    function buildBaseItems() {
      var qty = currentQty();
      var talla = currentTalla();
      var items = [];

      for (var i = 1; i <= qty; i++) {
        var color = unitColor(i);
        var info = variantMap[talla + '__' + color];
        if (!info || !info.available) {
          showError(
            'La combinación Talla ' + talla + ' / Color ' + color + ' (prenda ' + i + ') no tiene stock disponible.'
          );
          return null;
        }
        items.push({ id: info.id, quantity: 1 });
      }

      return items;
    }

    function buildItems() {
      var baseItems = buildBaseItems();
      if (!baseItems) return null;

      var packs = currentPacks();
      var items = [];
      for (var p = 0; p < packs; p++) {
        items = items.concat(baseItems);
      }
      return items;
    }

    function addToCart(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      }).then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      });
    }

    function notifyCartUpdate() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'tank-top-combo-buy',
                data: {
                  itemCount: cart.item_count,
                  source: 'tank-top-combo-buy',
                },
              },
            })
          );
        })
        .catch(function () {
          // El agregado ya sucedió; si esto falla el ícono simplemente no se actualiza al instante.
        });
    }

    function handleAddToCart() {
      hideError();
      var items = buildItems();
      if (!items) return;

      addButton.disabled = true;

      addToCart(items)
        .then(function (result) {
          if (!result.ok) {
            var message =
              (result.data && (result.data.description || result.data.message)) || 'No se pudo agregar al carrito.';
            showError(message);
            addButton.disabled = false;
            return;
          }
          return notifyCartUpdate().then(function () {
            var original = addButtonText.textContent;
            addButtonText.textContent = 'Agregado ✓';
            setTimeout(function () {
              addButtonText.textContent = original;
              addButton.disabled = false;
            }, 1500);
          });
        })
        .catch(function () {
          showError('No se pudo agregar al carrito. Intenta de nuevo.');
          addButton.disabled = false;
        });
    }

    function handleBuyNow() {
      hideError();
      var items = buildItems();
      if (!items) return;

      buyNowButton.disabled = true;

      addToCart(items)
        .then(function (result) {
          if (!result.ok) {
            var message =
              (result.data && (result.data.description || result.data.message)) || 'No se pudo agregar al carrito.';
            showError(message);
            buyNowButton.disabled = false;
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(function () {
          showError('No se pudo agregar al carrito. Intenta de nuevo.');
          buyNowButton.disabled = false;
        });
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-combo-qty]')) {
        refresh();
      } else if (event.target.matches('[data-combo-talla]')) {
        updateAvailability();
        updateLabels();
      } else if (event.target.matches('[data-combo-color]')) {
        updateLabels();
        hideError();
      }
    });

    addButton.addEventListener('click', handleAddToCart);
    buyNowButton.addEventListener('click', handleBuyNow);

    packsMinus.addEventListener('click', function () {
      var next = currentPacks() - 1;
      if (next < 1) return;
      packsInput.value = String(next);
      updateMainPrice();
    });

    packsPlus.addEventListener('click', function () {
      packsInput.value = String(currentPacks() + 1);
      updateMainPrice();
    });

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-combo-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
